import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "link",
  "use": "link-usage",
  "viewBox": "0 0 20 20",
  "content": "<symbol viewBox=\"0 0 20 20\" id=\"link\"><title>link</title><path d=\"M11.88,6.34l-.95.95A3.15,3.15,0,0,1,12,12.46L6.65,17.81a3.16,3.16,0,0,1-4.46-4.46l2.23-2.23-.89-.89L1.29,12.46a4.42,4.42,0,0,0,6.25,6.25l5.36-5.36a4.41,4.41,0,0,0-1-7Zm6.83-5a4.42,4.42,0,0,0-6.25,0L7.1,6.65a4.42,4.42,0,0,0,1,7l.95-1A3.15,3.15,0,0,1,8,7.54l5.36-5.36a3.16,3.16,0,0,1,4.46,4.46L15.58,8.88l.89.89,2.23-2.23A4.42,4.42,0,0,0,18.71,1.29Z\" transform=\"translate(0 0)\" fill-rule=\"evenodd\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/common/link.svg
// module id = s3+7
// module chunks = 264